import { render, staticRenderFns } from "./Wine.vue?vue&type=template&id=6b4e2700&scoped=true&"
import script from "./Wine.vue?vue&type=script&lang=js&"
export * from "./Wine.vue?vue&type=script&lang=js&"
import style0 from "./Wine.vue?vue&type=style&index=0&id=6b4e2700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e2700",
  null
  
)

export default component.exports